<template>
  <sf-alert-base :icon="mdiAlertOutline" type="warning" color="orange-darken-2">
    <slot />
  </sf-alert-base>
</template>

<script setup lang="ts">
import SfAlertBase from '@/components/alerts/SfAlertBase.vue'

import { mdiAlertOutline } from '@mdi/js'
</script>
